// extracted by mini-css-extract-plugin
export var checkIcon = "_5-2";
export var heading = "_5-1";
export var panel = "_5-0";